// Base
import React from "react";

// Types
import type { ReactNode } from "react";

interface BoxProps {
  children: ReactNode;
  className?: string;
}

const Box: React.FC<BoxProps> = ({ children, className }) => {
  return (
    <div
      className={`${className} border-cc-gray-4 flex flex-col rounded-[10px] border md:max-w-[538px]`}
    >
      {children}
    </div>
  );
};

export default Box;
